import { FaGift } from "react-icons/fa";
import { defineType, defineField } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "specialPerksType",
  title: "Special Perks Type",
  type: "document",
  icon: FaGift,
  preview: {
    select: { title: "title" },
    prepare: ({ title }) => ({
      title: multilingualStringPreview(title)
    })
  },
  fields: [
    defineField({
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    })
  ]
});
